import { Sorts } from "../enums/sorts";

export class SDKDataGridSort {
    public position?: number;
    public direction?: Sorts;
}